import { render } from "./TempSavedImplants.vue?vue&type=template&id=60016904&scoped=true"
import script from "./TempSavedImplants.vue?vue&type=script&lang=js"
export * from "./TempSavedImplants.vue?vue&type=script&lang=js"

import "./TempSavedImplants.vue?vue&type=style&index=0&id=60016904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60016904"]])

export default __exports__